import fetch from 'unfetch';

const zipCodeServiceURL = 'https://viacep.com.br/ws/';

const STATES = {
  AC: 'Acre',
  AL: 'Alagoas',
  AP: 'Amapá',
  AM: 'Amazonas',
  BA: 'Bahia',
  CE: 'Ceará',
  DF: 'Distrito Federal',
  ES: 'Espírito Santo',
  GO: 'Goiás',
  MA: 'Maranhão',
  MT: 'Mato Grosso',
  MS: 'Mato Grosso do Sul',
  MG: 'Minas Gerais',
  PA: 'Pará',
  PB: 'Paraíba',
  PR: 'Paraná',
  PE: 'Pernambuco',
  PI: 'Piauí',
  RJ: 'Rio de Janeiro',
  RN: 'Rio Grande do Norte',
  RS: 'Rio Grande do Sul',
  RO: 'Rondônia',
  RR: 'Roraima',
  SC: 'Santa Catarina',
  SP: 'São Paulo',
  SE: 'Sergipe',
  TO: 'Tocantins',
};

type STATE_ACRONYM =
  | 'AC'
  | 'AL'
  | 'AP'
  | 'AM'
  | 'BA'
  | 'CE'
  | 'DF'
  | 'ES'
  | 'GO'
  | 'MA'
  | 'MT'
  | 'MS'
  | 'MG'
  | 'PA'
  | 'PB'
  | 'PR'
  | 'PE'
  | 'PI'
  | 'RJ'
  | 'RN'
  | 'RS'
  | 'RO'
  | 'RR'
  | 'SC'
  | 'SP'
  | 'SE'
  | 'TO';

interface ViaCEPPayload {
  cep: string;
  logradouro: string;
  complemento: string;
  bairro: string;
  localidade: string;
  uf: STATE_ACRONYM;
  unidade: string;
  ibge: string;
  gia: string;
}

const translateZipCodeFields = (info: ViaCEPPayload) => {
  return {
    street: info.logradouro,
    neighborhood: info.bairro,
    city: info.localidade,
    state: STATES[info.uf],
    uf: info.uf,
  };
};

export const searchZipCode = async (zipCode: string) => {
  const strippedCode = zipCode.replace(/[^0-9]/g, '');
  if (strippedCode.length !== 8) {
    return null;
  }
  const requestUrl = `${zipCodeServiceURL}${strippedCode}/json`;
  let apiResponse: Response;
  try {
    // @ts-ignore
    apiResponse = await fetch(requestUrl, {
      method: 'GET',
    });
  } catch {
    return null;
  }

  const payload = await apiResponse.json();
  if (apiResponse.status !== 200 || payload.erro) return null;
  return translateZipCodeFields(payload as ViaCEPPayload);
};
